import { searchDiscover } from '../apis/discover';
import { setLike } from '../apis/social';

import {
  SET_SEARCH_TEXT,
  SET_TAB_TYPE,
  SEARCH_DISCOVER_LOADING,
  SEARCH_DISCOVER_SUCCESS,
  SEARCH_DISCOVER_FAIL,
  SEARCH_NEXT_DISCOVER_SUCCESS,
  SEARCH_NEXT_DISCOVER_FAIL,
  SET_SEARCH_LIKE,
} from '../actionTypes/search';
import { INIT_DISCOVER } from '../actionTypes/discover';
import { showRenderToast } from '../components/toast/toast';

export const POI_BANK_SUCCESS = 1;
export const POI_BANK_NO_RESULTS = 4;

const errorToast = message => {
  showRenderToast({ message }, 2000);
};

export const setSearchText = searchText => ({
  type: SET_SEARCH_TEXT,
  payload: searchText,
});

// export const setSearchQueryToUrl = () => ({ type: SET_SEARCH_QUERY });

export const setTabType = tabType => ({
  type: SET_TAB_TYPE,
  payload: { tabType },
});

const REDUCER_KEY = {
  'a,j,t,p': 'allData',
  'a,j': 'journalsData',
  'j,t': 'allData', // yahoo
  j: 'journalsData', // yahoo
  t: 'itinerariesData',
  p: 'productData',
};

export const searchDiscoverList = ({
  searchText,
  errorText,
  tabType,
}) => dispatch => {
  const key = REDUCER_KEY[tabType];
  dispatch({
    type: SEARCH_DISCOVER_LOADING,
    payload: {
      searchText,
    },
  });
  return searchDiscover({ searchText, type: tabType })
    .then(({ data }) => {
      if (data && data.code === POI_BANK_SUCCESS) {
        dispatch({
          type: SEARCH_DISCOVER_SUCCESS,
          payload: {
            data: data.data,
            dataNext: data.data_next,
            statusCode: data.code,
            key,
          },
        });
      } else if (data && data.code === POI_BANK_NO_RESULTS) {
        dispatch({
          type: SEARCH_DISCOVER_SUCCESS,
          payload: {
            data: [],
            dataNext: false,
            statusCode: data.code,
            key,
          },
        });
      } else {
        dispatch({
          type: SEARCH_DISCOVER_FAIL,
          payload: { data: [], statusCode: data.code, key },
        });
        errorToast(errorText);
      }
    })
    .catch(error => {
      console.error(error);
      dispatch({
        type: SEARCH_DISCOVER_FAIL,
        payload: {
          data: [],
          statusCode: 0,
          key,
        },
      });
      errorToast(errorText);
    });
};

export const searchNextDiscoverList = params => dispatch => {
  const { searchText, offset, errorText, type } = params;

  const key = REDUCER_KEY[type];
  return searchDiscover({ searchText, offset, type })
    .then(({ data }) => {
      if (data && data.code === POI_BANK_SUCCESS) {
        dispatch({
          type: SEARCH_NEXT_DISCOVER_SUCCESS,
          payload: {
            data: data.data,
            dataNext: data.data_next,
            statusCode: data.code,
            key,
          },
        });
      } else {
        dispatch({
          type: SEARCH_NEXT_DISCOVER_FAIL,
          payload: {
            data: [],
            statusCode: data.code,
            key,
          },
        });
        errorToast(errorText);
      }
    })
    .catch(error => {
      console.error(error);
      dispatch({
        type: SEARCH_DISCOVER_FAIL,
        payload: { data: [], statusCode: 0, key },
      });
      errorToast(errorText);
    });
};

export const initDiscover = () => ({ type: INIT_DISCOVER });

export const setSearchLike = params => dispatch => {
  const { userid, id, status, index, type, tabType, errorText } = params;
  return setLike({ userid, id, status, type })
    .then(response => {
      if (response.status !== 200 || response.data.status !== '200') {
        errorToast(errorText);
      } else {
        dispatch({
          type: SET_SEARCH_LIKE,
          payload: {
            isLike: response.data.results.is_like,
            index,
            key: REDUCER_KEY[tabType],
          },
        });
      }
    })
    .catch(error => {
      console.error('setSearchLike Error', error);
      errorToast(errorText);
    });
};
